import { render } from "./TextSplitter.vue?vue&type=template&id=558d48f7"
import script from "./TextSplitter.vue?vue&type=script&lang=js"
export * from "./TextSplitter.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/SignSentence/SignSentence/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__